<template>
  <v-container>
    <v-row>
      <v-col stretch>
        <v-breadcrumb :items="breadcrumbImportItems" :mobile="breadcrumbMobileItem"></v-breadcrumb>
      </v-col>
    </v-row>
    <v-row>
      <v-col stretch>
        <v-title-bar wrap :title="$t('titles.createImport')">
          <v-button
            class="wrap-btn"
            primary
            :active="teamCan('imports')"
            :withLockIcon="!teamCan('imports')"
            @click.native="submitImport"
            >{{ $t("actions.createImport") }}</v-button
          >
        </v-title-bar>
      </v-col>
    </v-row>
    <form @submit.prevent>
      <v-row>
        <v-col class="col-12 md:col-6">
          <v2-select
            :label="$t('imports.type')"
            :placeholder="$t('forms.required')"
            v-model="importType"
            name="type"
            optionLabel="label"
            :options="importTypeOptions"
            v-validate="'required'"
            :error="errors.first('type')"
            :data-vv-as="$t('imports.type')"
          ></v2-select>
          <v2-textfield
            :label="$t('imports.title')"
            :placeholder="$t('forms.required')"
            v-model="title"
            name="title"
            :error="errors.first('title')"
            v-validate="'required'"
            :data-vv-as="$t('imports.title')"
          />
          <v-file-upload
            :maxSize="5000"
            accept="application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            :allowedFileTypes="allowedFileTypes"
            @invalid="
              (errors) => {
                setErrors(errors);
              }
            "
            :customFileErrors="customFileErrors"
            :btn-text="$t('actions.selectFile')"
            @change="
              (files, fileList) => {
                handleFiles(files, fileList);
              }
            "
          >
          </v-file-upload>
          <div class="flex items-center mb-1 mt-8">
            <v2-icon
              style="margin-left: -2px; margin-right: 4px"
              :original="true"
              :data="require('@icon/Icon=info.svg')"
              width="25"
              height="25"
            ></v2-icon>
            {{ $t("imports.text.title") }}
          </div>
          <p>
            {{ $t("imports.text.text") }} <br />
            <a @click="downloadTemplate" class="v1 simple text-link">{{ $t("imports.text.link") }}</a>
          </p>
        </v-col>
        <v-col class="col-12">
          <div class="w-full flex justify-end">
            <v-button
              primary
              :active="teamCan('imports')"
              :withLockIcon="!teamCan('imports')"
              @click.native="submitImport"
              >{{ $t("actions.createImport") }}</v-button
            >
          </div>
        </v-col>
      </v-row>
    </form>
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import teamAbilities from "@/mixins/teamAbilities.js";

export default {
  name: "FormImport",
  mixins: [teamAbilities],
  data() {
    return {
      breadcrumbImportItems: [
        {
          label: this.$t("menus.settings"),
          route: { name: "Settings", params: { tab: "account" } },
        },
        {
          label: this.$t("menus.imports"),
          route: { name: "Settings", params: { tab: "imports" } },
        },
        {
          label: this.$t("menus.createImport"),
          active: true,
        },
      ],
      breadcrumbMobileItem: {
        label: this.$t("menus.imports"),
        route: { name: "Settings", params: { tab: "imports" } },
      },
      isLoading: false,
      title: "",
      importType: {},
      importTypeOptions: [{ label: this.$t("imports.types.clients"), value: "clients" }],
      allowedFileTypes: [
        "application/vnd.ms-excel",
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      ],
      excel: null,
      file: null,
      currentExcel: null,
      customFileErrors: [],
      noFile: false,
    };
  },
  created() {
    this.importType = this.importTypeOptions[0];
  },
  methods: {
    ...mapActions(["createImport", "getImports", "getImportColumnTemplate", "addCustomFilterToListsettings"]),
    downloadTemplate() {
      const vm = this;
      this.getImportColumnTemplate({
        params: {
          type: this.importType.value,
          locale: this.teams[this.$route.params.team].account.locale,
          page: "",
          per_page: "",
          order_col: "",
          order_dir: "",
        },
      })
        .then((response) => {
          console.log("response", response);
          window.open(response.data.url, "_blank");
        })
        .catch((err) => {
          if (err.response && !err.response.data.error.custom) {
            vm.$snotify.error(vm.$t("toasts.contactForm.validation"), vm.$t("toasts.error"), {
              timeout: 0,
              icon: vm.$errorIcon,
            });
          }
        });
    },
    handleFiles(files, fileList) {
      this.excel = files[0];
      this.file = fileList[0];
      const reader = new FileReader();
      reader.onload = () => {
        this.currentExcel = reader.result;
      };
      if (this.excel) reader.readAsDataURL(this.file);
      this.noFile = this.excel == null;
      this.customFileErrors = [];
    },
    setErrors(errors) {
      this.customFileErrors = errors;
    },
    submitImport() {
      if (!this.teamCan("imports")) {
        this.$h.showSubscriptionErrorModal(
          this.$modal,
          this.teams[this.$route.params.team] && this.teams[this.$route.params.team].account.role.includes("owner")
        );
      } else {
        const vm = this;
        this.noFile = this.excel == null;
        const data = {
          title: vm.title,
          file: vm.file,
          file_size: vm.excel ? vm.excel.size : 0,
          mime_type: vm.excel ? vm.excel.type : "",
          file_name: vm.excel ? vm.excel.name : "",
          import_type: vm.importType.value,
        };
        vm.$validator.validateAll().then((result) => {
          if (result && vm.excel && vm.customFileErrors.length < 1) {
            vm.createImport({ data: data })
              .then((res) => {
                vm.$snotify.success(vm.$t("toasts.createdImport.success"), vm.$t("toasts.success"), {
                  icon: vm.$successIcon,
                });
                vm.$goTo("Import", { uid: res.uid });
              })
              .catch((err) => {
                if (err.response && !err.response.data.error.custom) {
                  vm.$snotify.error(vm.$t("toasts.createdImport.error"), vm.$t("toasts.error"), {
                    timeout: 0,
                    icon: vm.$errorIcon,
                  });
                }
              });
          } else {
            if (this.noFile) {
              this.customFileErrors.push(this.$t("imports.file_required"));
            }
            vm.$snotify.error(vm.$t("toasts.importForm.validation"), vm.$t("toasts.error"), {
              timeout: 0,
              icon: vm.$errorIcon,
            });
          }
        });
      }
    },
  },
  computed: {
    ...mapGetters({
      teams: "auth_get_teams",
      teamLanguages: "teams_get_languages",
      teamsSettings: "global_get_teams_settings",
    }),
  },
};
</script>
